import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import axios from "axios";
import API_ENDPOINTS from "config/api";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function MovimientosRecientes() {
  const [movimientos, setMovimientos] = useState([]);
  const empresaId = localStorage.getItem("empresaId");

  useEffect(() => {
    fetchMovimientosRecientes();
  }, [empresaId]);

  const fetchMovimientosRecientes = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.MOVIMIENTOS, {
        params: { empresa_id: empresaId, limit: 5 },
      });
      setMovimientos(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error al obtener movimientos recientes:", error);
      setMovimientos([]);
    }
  };

  const getTipoColor = (tipo) => {
    const colores = {
      entrada: "success",
      salida: "error",
      ajuste: "warning",
      transferencia: "info",
    };
    return colores[tipo] || "default";
  };

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Movimientos Recientes
        </MDTypography>
        <Icon fontSize="default" color="info">
          swap_horiz
        </Icon>
      </MDBox>
      <MDBox pt={3} pb={2} px={2}>
        {movimientos.length > 0 ? (
          movimientos.map((movimiento, index) => (
            <MDBox key={movimiento.id}>
              <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <MDBox>
                  <MDTypography variant="button" fontWeight="medium" color="text">
                    {movimiento.producto?.nombre}
                  </MDTypography>
                  <MDTypography variant="caption" color="text" display="block">
                    {new Date(movimiento.fecha).toLocaleDateString()} - {movimiento.cantidad}{" "}
                    {movimiento.producto?.unidad_medida}
                  </MDTypography>
                </MDBox>
                <Chip
                  label={movimiento.tipo_movimiento}
                  color={getTipoColor(movimiento.tipo_movimiento)}
                  size="small"
                />
              </MDBox>
              {index < movimientos.length - 1 && <Divider />}
            </MDBox>
          ))
        ) : (
          <MDTypography variant="caption" color="text">
            No hay movimientos recientes
          </MDTypography>
        )}
      </MDBox>
    </Card>
  );
}
